import { render, staticRenderFns } from "./AppCheckbox.vue?vue&type=template&id=20dbb073&scoped=true&"
import script from "./AppCheckbox.vue?vue&type=script&lang=ts&"
export * from "./AppCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./AppCheckbox.vue?vue&type=style&index=0&id=20dbb073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dbb073",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
